import styled from 'styled-components'
import { Form } from 'formik'

import theme from 'theme_'
import { NetworkWizardContainer } from '../../styles'

export const AddNetworkFormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
`
export const AddNetworkContainer = styled(NetworkWizardContainer)`
  gap: 16px;
`

export const AddNetworkGoogleMapWrapper = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 8px;
  padding-bottom: ${theme.spacing.base};
`
